const SKIN = "#FFCB4C";
const SHADE = "#F4A62A";
const INK = "#5B3A1A";

function Base({ children, title, size }) {
  return (
    <svg
      viewBox="0 0 100 100"
      width={size}
      height={size}
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
    >
      {title && <title>{title}</title>}
      <defs>
        <radialGradient id="r21-face-skin" cx="40%" cy="35%" r="70%">
          <stop offset="0%" stopColor="#FFE07D" />
          <stop offset="70%" stopColor={SKIN} />
          <stop offset="100%" stopColor={SHADE} />
        </radialGradient>
      </defs>
      <circle cx="50" cy="50" r="46" fill="url(#r21-face-skin)" />
      <circle cx="50" cy="50" r="46" fill="none" stroke={SHADE} strokeWidth="2" />
      {children}
    </svg>
  );
}

const FACES = {
  very_happy: (
    <>
      <ellipse cx="35" cy="37" rx="5" ry="7.5" fill={INK} />
      <ellipse cx="65" cy="37" rx="5" ry="7.5" fill={INK} />
      <path d="M25 53 H75 Q74 84 50 84 Q26 84 25 53 Z" fill={INK} />
      <path d="M27 53 H73 Q72.6 59 71.5 62 H28.5 Q27.4 59 27 53 Z" fill="#fff" />
      <path d="M37 78 Q50 69 63 78 Q57 83 50 83 Q43 83 37 78 Z" fill="#E8596E" />
    </>
  ),
  happy: (
    <>
      <path d="M26 44 Q35 33 44 44" fill="none" stroke={INK} strokeWidth="5" strokeLinecap="round" />
      <path d="M56 44 Q65 33 74 44" fill="none" stroke={INK} strokeWidth="5" strokeLinecap="round" />
      <circle cx="25" cy="59" r="7" fill="#FF8A65" opacity="0.45" />
      <circle cx="75" cy="59" r="7" fill="#FF8A65" opacity="0.45" />
      <path d="M32 61 Q50 79 68 61" fill="none" stroke={INK} strokeWidth="5" strokeLinecap="round" />
    </>
  ),
  unhappy: (
    <>
      {/* Unimpressed side-glance: half-lidded eyes looking aside, flat mouth. */}
      <path d="M25 34 Q34 31 43 34" fill="none" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
      <path d="M57 34 Q66 31 75 34" fill="none" stroke={INK} strokeWidth="3.5" strokeLinecap="round" />
      <path d="M25 42 H45 Q45 53 35 53 Q25 53 25 42 Z" fill="#fff" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
      <path d="M55 42 H75 Q75 53 65 53 Q55 53 55 42 Z" fill="#fff" stroke={INK} strokeWidth="2.5" strokeLinejoin="round" />
      <circle cx="41" cy="46" r="3.6" fill={INK} />
      <circle cx="71" cy="46" r="3.6" fill={INK} />
      <path d="M38 71 Q51 66 64 70" fill="none" stroke={INK} strokeWidth="5" strokeLinecap="round" />
    </>
  ),
  sad: (
    <>
      <path d="M25 35 L39 30" stroke={INK} strokeWidth="4" strokeLinecap="round" />
      <path d="M75 35 L61 30" stroke={INK} strokeWidth="4" strokeLinecap="round" />
      <ellipse cx="35" cy="44" rx="4.5" ry="6" fill={INK} />
      <ellipse cx="65" cy="44" rx="4.5" ry="6" fill={INK} />
      <path d="M32 74 Q50 58 68 74" fill="none" stroke={INK} strokeWidth="5" strokeLinecap="round" />
      <path d="M68 52 Q74 62 71 67 Q67 71 64 67 Q62 62 68 52 Z" fill="#5EB3F0" />
    </>
  ),
};

export default function EmojiFace({ face, size = 96, title }) {
  return (
    <Base size={size} title={title}>
      {FACES[face] ?? FACES.happy}
    </Base>
  );
}

export const FACE_NAMES = Object.keys(FACES);
